import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Outlet, NavLink } from 'react-router-dom';
import useMatchMedia from 'hooks/useMatchMedia';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import { LEAD_STAGES } from 'models/Lead';
import DealContext from '../../providers/Deal/Deal.context';

import './WorkflowConfiguration.styles.scss';
import './WorkflowConfiguration.styles.responsive.scss';

const WorkflowConfiguration: React.FC = () => {
  const { leadStagesCopies } = useContext(DealContext);

  const isAbovePhablet = useMatchMedia('isAbovePhablet');

  const { t } = useTranslation();

  return (
    <div className="workflow-configuration">
      <div className="workflow-configuration__header">
        <p>{t('automation')}</p>
      </div>
      <div className="workflow-configuration__content">
        <aside>
          <nav>
            <ul className="workflow-configuration__menu">
              {Object.values(LEAD_STAGES).map((step, index) => (
                <li key={step}>
                  <NavLink
                    className={({ isActive }) =>
                      classNames({ active: isActive })
                    }
                    to={step}
                    replace={isAbovePhablet}
                  >
                    <div className="workflow-configuration__link-info">
                      <p>{`${t('stage')} ${index + 1}`}</p>
                      <p>{t(leadStagesCopies[step])}</p>
                    </div>
                    <CheckcircleIcon />
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default WorkflowConfiguration;
